import { observable, action } from 'mobx';

class AuthStore {
    @observable isLoggedIn = false;
    @observable userName = '';
    @observable displayName = '';
    @observable userRoles: string[] = [];
    @observable isReadOnly = false;
    @observable accessToken: string = '';
    @observable refreshReportToken: string = '';

    @action
    setLoggedInStatus(isLoggedIn) {
        this.isLoggedIn = isLoggedIn;
    }

    @action
    setUsername(userName) {
        this.userName = userName;
    }

    @action
    setDisplayName(displayName) {
        this.displayName = displayName;
    }

    @action
    setUserRole(roles) {
        this.userRoles = roles;
    }

    @action
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }

    @action
    setRefreshReportToken(refreshReportToken) {
        this.refreshReportToken = refreshReportToken;
    }

    @action
    setLogOutItems() {
        this.isLoggedIn = false;
        this.userName = '';
        this.displayName = '';
        this.userRoles = [];
    }

    @action
    setAuthInfo(tokenInfo,IsLoggedIn){
        this.userName = tokenInfo.userName;
        this.displayName = tokenInfo.displayName;
        this.isLoggedIn = IsLoggedIn;
        this.userRoles = tokenInfo.roles;        
    }

}

export default new AuthStore();